/* eslint-disable no-restricted-imports */
/**
 * Client-side Supabase configuration
 * Use this for components, hooks, and client-side operations
 */

import { createBrowserClient } from '@supabase/ssr'

import type { Database } from '@/types/database'
import type { SupabaseClient } from '@supabase/supabase-js'

// Environment variables with proper fallbacks
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Singleton client instance to ensure consistent auth state
let clientInstance: SupabaseClient<Database> | null = null

/**
 * Browser client for client-side operations
 * Uses singleton pattern to ensure consistent authentication state
 */
export function createClient(): SupabaseClient<Database> {
  clientInstance ??= createBrowserClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce'
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    }
  })
  return clientInstance
}

/**
 * Default client instance for convenience
 */
export const supabase = createClient()

/**
 * @deprecated Use `supabase` directly — guests now have real auth sessions via Anonymous Auth.
 * Kept temporarily for callers that haven't been updated.
 */
export function getSupabaseForSession(_sessionId?: string | null): SupabaseClient<Database> {
  return supabase
}
